import type {
  DocumentReferenceField,
  DocumentReferenceFieldTax,
} from 'types/repository.types';
import DocumentRepositoryFieldItem from './DocumentRepositoryFieldItem';
import { useTranslation } from 'react-i18next';
import TaxFieldValue from './DocumentRepositoryTaxFieldValue';
import { UserFeatures } from 'types/users.types';
import { useIsFeatureEligible } from 'hooks/useIsFeatureEligible';

import type { JSX } from 'react';

type DocumentRepositoryTaxDebugFieldProps = {
  field: DocumentReferenceField & DocumentReferenceFieldTax;
  documentId: string;
  setBoundingBoxField: (field: string | null) => void;
};

const DocumentRepositoryTaxDebugField = ({
  field,
  setBoundingBoxField,
}: DocumentRepositoryTaxDebugFieldProps): JSX.Element | null => {
  const { t } = useTranslation();

  const handleAccept = () => {};

  const handleReject = () => {};

  const shouldSeeDebugFields = useIsFeatureEligible(
    UserFeatures.MINFIN_DOCUMENT_EXTRACTOR,
  );
  if (!shouldSeeDebugFields) return null;

  return (
    <DocumentRepositoryFieldItem
      field={field}
      onAccept={handleAccept}
      onReject={handleReject}
      title="Just for debugging"
      description="It will not be shown to the user."
      acceptButtonLabel={t('repository.document_form.fields.accept')}
      rejectButtonLabel={t('repository.document_form.fields.reject')}
    >
      <div className="flex flex-col gap-2 mt-2">
        {Object.entries(field.value).map(([key, value]) => (
          <TaxFieldValue
            key={key}
            setBoundingBoxField={setBoundingBoxField}
            label={t(`repository.document_form.fields.tax.${key}`)}
            value={String(value)}
            fieldName={`tax.${key}`}
          />
        ))}
      </div>
    </DocumentRepositoryFieldItem>
  );
};

export default DocumentRepositoryTaxDebugField;
